import { c as _c } from "react/compiler-runtime";
import type { DetailedHTMLProps, HTMLAttributes } from 'react';
import { polyfillCountryFlagEmojis } from 'country-flag-emoji-polyfill';
import { cn } from '@/lib/cn';
import { countryCodeToFlagEmoji } from '@/lib/utils/countryCodeToFlagEmoji';
polyfillCountryFlagEmojis();
export interface CountryFlagProps extends DetailedHTMLProps<HTMLAttributes<HTMLSpanElement>, HTMLSpanElement> {
  countryCode?: string;
}
export function CountryFlag(t0) {
  const $ = _c(12);
  let className;
  let countryCode;
  let props;
  if ($[0] !== t0) {
    ({
      countryCode,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = countryCode;
    $[3] = props;
  } else {
    className = $[1];
    countryCode = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn("font-[Twemoji_Country_Flags]", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== countryCode) {
    t2 = countryCodeToFlagEmoji(countryCode);
    $[6] = countryCode;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== props || $[9] !== t1 || $[10] !== t2) {
    t3 = <span {...props} className={t1}>{t2}</span>;
    $[8] = props;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}